import { AfterViewInit, Component } from '@angular/core';
import { first } from 'rxjs';
import { GungTroubleshootingService, GungTroubleshootingMenuItem } from '../../services/gung-troubleshooting/gung-troubleshooting.service';

@Component({
  selector: 'lib-gung-troubleshooting',
  templateUrl: './gung-troubleshooting.component.html',
  styleUrl: './gung-troubleshooting.component.scss',
  standalone: false
})
export class GungTroubleshootingComponent implements AfterViewInit {
  public gungTroubleshootingMenu: GungTroubleshootingMenuItem[] = [];

  constructor(
    protected gungTroubleshootingService: GungTroubleshootingService,
  ) { }

  ngAfterViewInit(): void {
    this.gungTroubleshootingService.getGungTroubleshootingMenu().pipe(first()).subscribe(menu => {
      this.gungTroubleshootingMenu = menu;
    });
  }
}
